document.addEventListener("DOMContentLoaded", function() {
  // Open job position apply info by title tab
  var jobsRows = document.querySelectorAll(".jobs-row");
  jobsRows.forEach(function(row) {
    row.addEventListener("click", function() {
      var applySection = this.nextElementSibling;
      if (applySection) {
        applySection.style.display = "block";
        applySection.style.transition = "height 0.3s ease-in-out";
        applySection.style.height = applySection.scrollHeight + "px";
      }
    });
  });

  // Close job position apply info by close button
  var applyCloseButtons = document.querySelectorAll(".apply__close");
  applyCloseButtons.forEach(function(button) {
    button.addEventListener("click", function() {
      var applySection = this.closest(".apply__section");
      if (applySection) {
        applySection.style.height = "0";
        applySection.addEventListener("transitionend", function() {
          applySection.style.display = "none";
        }, { once: true });
      }
    });
  });
});
